import { SortPayload } from 'react-admin';

type ListParams = {
  displayedFilters?: Record<string, any>;
  sort?: SortPayload;
  page?: number;
  perPage?: number;
};

// Собирает строку search в формате react-admin, сохраняя уже присутствующие в URL
// параметры. Используется для записи фильтров через navigate(..., { replace: true }),
// чтобы дефолтные фильтры отображались в URL, не плодя записи в history.
export function buildFilterSearch(
  currentSearch: string,
  filter: Record<string, any>,
  { displayedFilters, sort, page, perPage }: ListParams = {},
): string {
  const params = new URLSearchParams(currentSearch);

  params.set('filter', JSON.stringify(filter));

  if (!params.has('displayedFilters')) {
    params.set('displayedFilters', JSON.stringify(displayedFilters ?? {}));
  }
  if (!params.has('sort') && sort?.field) {
    params.set('sort', sort.field);
    params.set('order', sort.order);
  }
  if (!params.has('page')) {
    params.set('page', String(page ?? 1));
  }
  if (!params.has('perPage')) {
    params.set('perPage', String(perPage ?? 10));
  }

  return `?${params.toString()}`;
}
